module.exports = __webpack_public_path__ + "img/infiniti.5cf5ccb2.png";